import React, { useEffect, useRef, useState } from "react"
import { Card, Col, PopoverBody, Row, UncontrolledPopover } from "reactstrap"
import UpdateTable from "../../../components/Common/UpdatedTable"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import action from "../../../assets/icons/action.svg"
import EditCostCenterFinance from "./edit"
import { toastError, toastSuccess } from "../../../helpers/msg_helper"
import { createSelector } from "reselect"
import { useSelector } from "react-redux"
import {
  fetchFinanceCostCentetSearch,
  updateCatStatus,
} from "../../../services/finance/finance"
import FinanceFilter from "../filter"
import { capitalize } from "lodash"
import { useLocation, useNavigate } from "react-router-dom"

const CostCenetrFinanceSearch = () => {
  const companyname = localStorage.getItem("companyname")
  document.title = `Finance Cost Center${companyname ? ` | ${companyname}` : "MEP -Hub"
    }`

  const selectLoginState = state => state.Login
  const LoginProperties = createSelector(selectLoginState, login => ({
    loggedUser: login.loggedUser,
  }))

  const { loggedUser } = useSelector(LoginProperties)

  const locations = useLocation();
  const crumb = locations?.state?.menuLabel || ""

  const navigate = useNavigate()

  const [page, setPage] = useState("")

  const [series, setSeries] = useState()
  const [status, setStatus] = useState("")
  const [search, setSearch] = useState("")
  const [count, setCount] = useState(0)
  const [editSeries, setEditSeries] = useState({ modal: false, value: "" })
  const [catFil, setCatFil] = useState("")
  const [dataPerPage, setDataPerPage] = useState(25)
  const [isLoadingNextPage, setIsLoadingNextPage] = useState(false)

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetchFinanceCostCentetSearch({
        params: `${search ? `?searchText=${search}` : "?searchText"}${page ? `&page=${page}` : ""
          }${`&sortOrder=asc`}${dataPerPage ? `&sizePerPage=${dataPerPage}` : ""}`,
      })
      const filteredData = response?.data?.filter(item => item.id !== 1);

      const updatedResponse = {
        ...response,             // keep all other properties
        data: filteredData,      // update data with filtered array
      };

      // setSeries(updatedResponse)

      setSeries(prev =>
        page > 1 && prev
          ? {
            ...response,
            data: [...(prev.data || []), ...filteredData],
          }
          : {
            ...response,
            data: filteredData,
          }
      );
      setIsLoadingNextPage(response == undefined ? true : false)
      isLoadingRef.current = false;
    }
    fetchData()
  }, [count, status, search, page, catFil, dataPerPage])

  const tableContainerRef = useRef(null)
  const isLoadingRef = useRef(false);
  const scrollTimeoutRef = useRef(null);

  useEffect(() => {
    const handleScroll = (e) => {
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
      
      scrollTimeoutRef.current = setTimeout(() => {
        if (
          scrollTop + clientHeight >= scrollHeight - 50 &&
          !isLoadingRef.current &&
          page < series?.last_page
        ) {
          isLoadingRef.current = true;
          setIsLoadingNextPage(true);
          setPage(prev => prev + 1);
        }
      }, 200);
    };
    
    const container = tableContainerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }
    
    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
    };
  }, [series, page]);

  const handleEdit = item => {
    setEditSeries({ value: item, modal: true })
  }

  const handleStatus = async id => {
    try {
      const response = await updateCatStatus(id)
      toastSuccess(response?.message)
      setCount(count + 1)
    } catch (err) {
      toastError(err?.message)
    }
  }

  const handleSizePerPageChange = size => {
    setDataPerPage(size)
  }

  const columns = [
    {
      label: "Cost Center Name",
      renderCell: item => (
        <div>
          <div className="capitalize-letter pointer fw-bold" onClick={() => navigate(`/finance/cost-category-report`, { state: { productId: item?.id, productName: item?.name, bread: crumb } })}>
            {item?.name ? capitalize(item?.name) : "-"}
          </div>
        </div>
      ),
    },
    {
      label: "Cost Category",
      renderCell: item => (item?.cost_category?.name ? capitalize(item?.cost_category?.name) : "-"),
    },
    {
      label: "Under",
      renderCell: item => (item?.parent?.name ? capitalize(item?.parent?.name) : "-"),
    },
    {
      label: "Used for Job Costing",
      renderCell: item => (item?.used_for_job_costing ? "Yes" : "No"),
    },
    {
      label: "Action",
      renderCell: item => (
        <>
          <div>
            <span id={`PopoverLegacy-${item?.id}`}>
              <img
                src={action}
                alt=""
                className={item?.id != 1 ? "pointer" : ""}
              />
            </span>
          </div>
          {item?.id !== 1 && (
            <UncontrolledPopover
              placement="bottom"
              target={`PopoverLegacy-${item?.id}`}
              trigger="legacy"
            >
              <PopoverBody>
                {item?.id != 1 ? (
                  <div
                    className="table-popup-content"
                    onClick={() => handleEdit(item)}
                  >
                    Edit
                  </div>
                ) : (
                  <></>
                )}
              </PopoverBody>
            </UncontrolledPopover>
          )}
        </>
      ),
    },
  ]

  const handlePaginate = page => {
    setPage(page)
  }

  const handleUpdate = () => {
    setCount(count + 1)
  }

  const handleResetValue = () => {
    setEditSeries("")
  }

  const handleStatusChange = id => {
    setStatus(id)
    setPage(1)
  }
  const handleSearchChange = data => {
    setSearch(data)
    setPage(1)
  }

  const handleCategoryChange = data => {
    setCatFil(data)
    setPage(1)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <div className="d-flex justify-content-between">
            <Breadcrumbs
              title="Finance"
              breadcrumbObject={[
                { title: "Finance", link: "/finance" },
                {
                  title: crumb || "Master",
                  link: "/finance",
                },
                {
                  title: "Cost Center",
                  link: "/finance-cost-center",
                },
              ]}
            />
            {loggedUser?.settings?.multiple_cost_category ? (
              <EditCostCenterFinance
                key={"x"}
                onUpdate={handleUpdate}
                onReset={handleResetValue}
                buttonLabel="+&nbsp; Cost Center"
                className="px-2 mb-3 me-2 btn btn-primary"
                editItem={editSeries}
              />
            ) : (
              <></>
            )}
          </div>
          <Card className="me-2 px-2 pb-2">
            <FinanceFilter
              handleStatusChange={handleStatusChange}
              handleSearchChange={handleSearchChange}
              handleCategoryChange={handleCategoryChange}
              sampleUrl={"download/series.xlsx"}
              importUrl={"finance-sub-cat/import"}
              showExport={
                loggedUser?.permission?.some(
                  permissionItem =>
                    permissionItem?.name === "financesub-category_create"
                )
                  ? true
                  : false
              }
              isCat={false}
            />
            <hr className="table-divide" />
            <Row className="mt-2 ever-rise-table">
              <Col xs={12}>
                <div ref={tableContainerRef} style={{ maxHeight: "490px", overflowY: "auto" }}>
                  {series?.data && (
                    <UpdateTable
                      className="mt-5"
                      nodes={series?.data}
                      paginate={series}
                      CurrentPage={page}
                      columns={columns}
                      handlePagination={handlePaginate}
                      handleSizePerPage={handleSizePerPageChange}
                      tableWidth="30% 20% 20% 20% 10%"
                      mobileWidth="40% 40% 40% 40% 20%"
                      isLoading={isLoadingNextPage}
                      hidePaginate={true}
                    />
                  )}
                </div>
              </Col>
            </Row>
          </Card>
        </div>
      </div>
    </React.Fragment>
  )
}

export default CostCenetrFinanceSearch
